var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthernet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8406 11.5406L9.59062 1.04063C9.52046 0.950991 9.43082 0.878495 9.32849 0.828637C9.22616 0.778779 9.11382 0.752869 8.99999 0.752869C8.88616 0.752869 8.77383 0.778779 8.6715 0.828637C8.56916 0.878495 8.47952 0.950991 8.40937 1.04063L0.159373 11.5406C0.0543522 11.6707 -0.00292969 11.8328 -0.00292969 12C-0.00292969 12.1672 0.0543522 12.3293 0.159373 12.4594L8.40937 22.9594C8.47952 23.049 8.56916 23.1215 8.6715 23.1714C8.77383 23.2212 8.88616 23.2471 8.99999 23.2471C9.11382 23.2471 9.22616 23.2212 9.32849 23.1714C9.43082 23.1215 9.52046 23.049 9.59062 22.9594L17.8406 12.4594C17.9456 12.3293 18.0029 12.1672 18.0029 12C18.0029 11.8328 17.9456 11.6707 17.8406 11.5406ZM9.74999 3.66563L16.0687 11.7094L9.74999 14.5875V3.66563ZM8.24999 14.5875L1.93125 11.7094L8.24999 3.66563V14.5875ZM8.24999 16.2375V20.3344L3.24375 13.9594L8.24999 16.2375ZM9.74999 16.2375L14.7562 13.9594L9.74999 20.3344V16.2375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernet);
export default __webpack_public_path__ + "static/media/ethernet.834893f0e185eb4b6e43e2b3c356d881.svg";
export { ForwardRef as ReactComponent };